"use strict";
var import_vitest = require("vitest");
function _assert_this_initialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _call_super(_this, derived, args) {
  derived = _get_prototype_of(derived);
  return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _construct(Parent, args, Class) {
  if (_is_native_reflect_construct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function construct(Parent2, args2, Class2) {
      var a = [
        null
      ];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2) _set_prototype_of(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _create_class(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _get_prototype_of(o) {
  _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
  if (call && (_type_of(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
  _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _set_prototype_of(o, p);
}
function _type_of(obj) {
  "@swc/helpers - typeof";
  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrap_native_super = function wrapNativeSuper(Class2) {
    if (Class2 === null || !_is_native_function(Class2)) return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2)) return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _get_prototype_of(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _set_prototype_of(Wrapper, Class2);
  };
  return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
  try {
    var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (_) {
  }
  return (_is_native_reflect_construct = function() {
    return !!result;
  })();
}
var ReadOnlyURLSearchParams = /* @__PURE__ */ (function(URLSearchParams1) {
  "use strict";
  _inherits(ReadOnlyURLSearchParams2, URLSearchParams1);
  function ReadOnlyURLSearchParams2() {
    _class_call_check(this, ReadOnlyURLSearchParams2);
    return _call_super(this, ReadOnlyURLSearchParams2, arguments);
  }
  _create_class(ReadOnlyURLSearchParams2, [
    {
      key: "set",
      value: function set(_name, _value) {
        throw new Error("useSearchParams returns a read-only URLSearchParams object");
      }
    },
    {
      key: "append",
      value: function append(_name, _value) {
        throw new Error("useSearchParams returns a read-only URLSearchParams object");
      }
    },
    {
      key: "delete",
      value: function _delete(_name, _value) {
        throw new Error("useSearchParams returns a read-only URLSearchParams object");
      }
    }
  ]);
  return ReadOnlyURLSearchParams2;
})(_wrap_native_super(URLSearchParams));
(0, import_vitest.describe)("ReadOnlyURLSearchParams", function() {
  (0, import_vitest.it)("should allow reading values", function() {
    var params = new ReadOnlyURLSearchParams([
      [
        "sort",
        "price"
      ],
      [
        "category",
        "electronics"
      ]
    ]);
    (0, import_vitest.expect)(params.get("sort")).toBe("price");
    (0, import_vitest.expect)(params.get("category")).toBe("electronics");
    (0, import_vitest.expect)(params.get("nonexistent")).toBe(null);
  });
  (0, import_vitest.it)("should support has()", function() {
    var params = new ReadOnlyURLSearchParams([
      [
        "key",
        "value"
      ]
    ]);
    (0, import_vitest.expect)(params.has("key")).toBe(true);
    (0, import_vitest.expect)(params.has("missing")).toBe(false);
  });
  (0, import_vitest.it)("should support getAll() for repeated params", function() {
    var params = new ReadOnlyURLSearchParams([
      [
        "tag",
        "a"
      ],
      [
        "tag",
        "b"
      ],
      [
        "tag",
        "c"
      ]
    ]);
    (0, import_vitest.expect)(params.getAll("tag")).toEqual([
      "a",
      "b",
      "c"
    ]);
  });
  (0, import_vitest.it)("should support iteration", function() {
    var params = new ReadOnlyURLSearchParams([
      [
        "a",
        "1"
      ],
      [
        "b",
        "2"
      ]
    ]);
    var entries = Array.from(params.entries());
    (0, import_vitest.expect)(entries).toEqual([
      [
        "a",
        "1"
      ],
      [
        "b",
        "2"
      ]
    ]);
  });
  (0, import_vitest.it)("should support toString()", function() {
    var params = new ReadOnlyURLSearchParams([
      [
        "sort",
        "price"
      ],
      [
        "page",
        "1"
      ]
    ]);
    (0, import_vitest.expect)(params.toString()).toBe("sort=price&page=1");
  });
  (0, import_vitest.it)("should throw on set()", function() {
    var params = new ReadOnlyURLSearchParams([
      [
        "key",
        "value"
      ]
    ]);
    (0, import_vitest.expect)(function() {
      return params.set("key", "new");
    }).toThrow("useSearchParams returns a read-only URLSearchParams object");
  });
  (0, import_vitest.it)("should throw on append()", function() {
    var params = new ReadOnlyURLSearchParams([
      [
        "key",
        "value"
      ]
    ]);
    (0, import_vitest.expect)(function() {
      return params.append("key", "another");
    }).toThrow("useSearchParams returns a read-only URLSearchParams object");
  });
  (0, import_vitest.it)("should throw on delete()", function() {
    var params = new ReadOnlyURLSearchParams([
      [
        "key",
        "value"
      ]
    ]);
    (0, import_vitest.expect)(function() {
      return params.delete("key");
    }).toThrow("useSearchParams returns a read-only URLSearchParams object");
  });
});
(0, import_vitest.describe)("useSearchParams param conversion", function() {
  function paramsToEntries(params) {
    return Object.entries(params).flatMap(function(param) {
      var [key, value] = param;
      if (value === void 0) return [];
      return Array.isArray(value) ? value.map(function(v) {
        return [
          key,
          String(v)
        ];
      }) : [
        [
          key,
          String(value)
        ]
      ];
    });
  }
  (0, import_vitest.it)("should convert simple string params", function() {
    var params = {
      sort: "price",
      page: "1"
    };
    var entries = paramsToEntries(params);
    (0, import_vitest.expect)(entries).toEqual([
      [
        "sort",
        "price"
      ],
      [
        "page",
        "1"
      ]
    ]);
  });
  (0, import_vitest.it)("should expand array params into multiple entries", function() {
    var params = {
      tags: [
        "a",
        "b",
        "c"
      ]
    };
    var entries = paramsToEntries(params);
    (0, import_vitest.expect)(entries).toEqual([
      [
        "tags",
        "a"
      ],
      [
        "tags",
        "b"
      ],
      [
        "tags",
        "c"
      ]
    ]);
  });
  (0, import_vitest.it)("should filter out undefined values", function() {
    var params = {
      present: "yes",
      missing: void 0
    };
    var entries = paramsToEntries(params);
    (0, import_vitest.expect)(entries).toEqual([
      [
        "present",
        "yes"
      ]
    ]);
  });
  (0, import_vitest.it)("should handle mixed params", function() {
    var params = {
      single: "value",
      multiple: [
        "x",
        "y"
      ],
      absent: void 0
    };
    var entries = paramsToEntries(params);
    (0, import_vitest.expect)(entries).toEqual([
      [
        "single",
        "value"
      ],
      [
        "multiple",
        "x"
      ],
      [
        "multiple",
        "y"
      ]
    ]);
  });
  (0, import_vitest.it)("should handle empty params", function() {
    var params = {};
    var entries = paramsToEntries(params);
    (0, import_vitest.expect)(entries).toEqual([]);
  });
});
//# sourceMappingURL=hooks.test.js.map
